module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-searchbox-codcomp"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-md-6"
  }, [_c('hrms-lov-codcomp', {
    attrs: {
      "nowLang": _vm.nowLang,
      "name": "codcomp1",
      "descDisp": false
    },
    model: {
      value: (_vm.codcomp1),
      callback: function($$v) {
        _vm.codcomp1 = $$v
      },
      expression: "codcomp1"
    }
  }), _vm._v(" "), _c('hrms-lov-codcomp', {
    attrs: {
      "disabled": true,
      "nowLang": _vm.nowLang,
      "name": "codcomp1",
      "descDisp": false
    },
    model: {
      value: (_vm.codcomp1),
      callback: function($$v) {
        _vm.codcomp1 = $$v
      },
      expression: "codcomp1"
    }
  }), _vm._v(" "), _c('hrms-lov-codcomp', {
    attrs: {
      "nowLang": _vm.nowLang,
      "name": "codcomp2"
    },
    model: {
      value: (_vm.codcomp2),
      callback: function($$v) {
        _vm.codcomp2 = $$v
      },
      expression: "codcomp2"
    }
  })], 1)]), _vm._v(" "), _c('hrms-search-box', {
    attrs: {
      "receivedStore": _vm.receivedStore,
      "nowLang": _vm.nowLang,
      "searchBoxAlias": "demo-lov-codcomp"
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6776fdec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoSearchboxCodcomp.vue
// module id = 3827
// module chunks = 1